import { useFormState } from '@carboledger/ui';
import { FACILITY_KINDS, parseFacilityValue } from '@/config/formOptions';
import { TerminalField } from '@/components/common';
import { useTranslations } from '@/hooks';

const TERMINAL_CLEARS = Object.freeze(['materialId', 'unit']);

/**
 * Props:
 *   sites     the session's sites, which carry their terminals
 *   disabled  locks the control
 */
export const OrderTerminalField = ({ sites, disabled = false }) => {
  const t = useTranslations();
  const { values } = useFormState();

  // A back-to-back account has no terminals, so the field is dropped, not just disabled.
  if (parseFacilityValue(values.facilityId).kind === FACILITY_KINDS.backToBack) return null;

  return (
    <TerminalField
      sites={sites}
      label={t('FORM_TERMINAL_OPTIONAL')}
      clears={TERMINAL_CLEARS}
      disabled={disabled}
    />
  );
};
